module.exports = __webpack_public_path__ + "26d73e69dd5187f625a19385d2d31862.pdf";